<!--月报汇总页-->
<template>
  <!-- 路径 -->
  <div class="path">
    <span><router-link to="/"> 首页</router-link></span> 
    &nbsp; &gt; &nbsp;
    <span>交易月报汇总表</span>
  </div>
  <div class="card-box">
    <!-- <div class="flex-start mb_15">
      <div class="news_title1">交易月报汇总统计图</div>
      <div class="news_title2">&nbsp;</div>
    </div>    
    <div ref="echart_ref" class="com-chart"></div>
    <div class="flex-start mb_15">
      <div class="news_title1">交易月报汇总表</div>
      <div class="news_title2">&nbsp;</div>
    </div> -->
    <div class="title-box">    
      <div class="title-box-title">交易月报汇总表</div>        
    </div>
    
    <div class="search-div">
      月份：
      <el-date-picker
        v-model="dateValue"
        type="month"
        format="YYYY年MM月"
        value-format="YYYY-MM"             
      />
      <el-button type="primary" icon="search" @click="getListData">查询</el-button>
      <el-button type="primary" icon="Download" @click="getExportData">导出</el-button>
    </div>
    <el-table v-loading="tableLoading" :data="listData" highlight-current-row stripe border
        style="width: 100%" header-row-class-name="header-row">
      <!-- <el-table-column type="selection" width="40"></el-table-column>
      <el-table-column type="index" label="序" width="43"></el-table-column> -->
      <el-table-column prop="tradeDate" label="交易日期" min-width="130" />
      <el-table-column prop="tradeAmount" label="交易金额" min-width="130" align="right" />
      <el-table-column prop="feeAmount" label="手续费" min-width="130" align="right" />
      <el-table-column prop="tradeCount" label="交易笔数 " min-width="130" />
    </el-table>
    <div class="pagination">
      <el-pagination v-if="windowWidth >= 768" background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="currentPage" :page-sizes="[10, 15, 20, 30, 40]"
        :page-size="pagesize" layout="total, sizes, prev, pager, next, jumper" :total='tableTotal'>
      </el-pagination>
      <el-pagination v-else @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="currentPage" :pager-count="3"
        :page-size="pagesize" layout="total, prev, pager, next" :total='tableTotal' >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {formatCurrency} from '@/utils/chineseNum.js'
import dayjs from 'dayjs'
export default {
  data () {
    return {
      tableLoading: false,
      currentPage: 1,
      pagesize: 50,
      tableTotal: 0,
      listData: [],
      dateValue: dayjs().format('YYYY-MM'),
      // chartTitle: '',
      // startDate: '', // 交易开始日期
      // endDate: '', // 交易结束日期
      // chartInstance: null,
      isFirst: true // 是否第一次访问(不是分页访问)
    }
  },
  // 接收父组件传值
  props: {
    windowWidth: Number
  },
  computed: {
    rangeDate() {
      return [`${this.dateValue}-01`, dayjs(this.dateValue).endOf('month').format('YYYY-MM-DD')]
    }
  },
  mounted () {
    // var dt = dateFormate('yyyy-MM')
    this.getListData()
  },
  methods: {    
    // pageSize 新每页条数改变时触发(每页下拉显示数据)
    handleSizeChange (size) {
      this.pagesize = size
      this.getListData()
    },
    // 新当前页改变时触发(点击第几页)
    handleCurrentChange (currentPage) {
      this.currentPage = currentPage
      this.getListData()
    },
    // 采购明细
    async getListData () {
      this.tableLoading = true
      var en = {
        position: 'merchantTrade_queryTradeBillSummary',
        paramMap: {
          orgId: '9ce5a4d757f9d6434008b1449d20a641',
          startDate: this.rangeDate[0],
          endDate: this.rangeDate[1]
        },
        pageable: {
            pageNumber: this.currentPage,
            pageSize: this.pagesize
        }
      }
      const { data: res } = await this.$http.post(this.$api.querySqlByPage, en) 
      // console.log('Detail', res)
      if (res.state.code === 10000) {
        this.tableTotal = res.body.totalCount
        this.listData = res.body.list
        this.listData.forEach(p => {
          p.tradeCount = formatCurrency(p.tradeCount, 0)
          p.tradeAmount = '¥'+ formatCurrency(p.tradeAmount, 2)
          p.feeAmount = '¥'+ formatCurrency(p.feeAmount, 2)
        })  
      } else {
        this.$message.error(res.state.message)
      }
      this.tableLoading = false
    },
    async getExportData () {
      var exportFileName = `交易对账汇总表${this.dateValue}`
      var en = {
        "sheetDatas":
          {
            "fields": [
              "tradeDate",
              "tradeAmount",
              "feeAmount",
              "tradeCount"
            ],
            "titles": [
              "交易日期",
              "交易金额",
              "手续费",
              "交易笔数"
            ],
            "sheetName": '交易对账汇总表'
          },        
        "param": {
            "position": "merchantTrade_queryTradeBillSummary",
            "paramMap": {
              "orgId": "9ce5a4d757f9d6434008b1449d20a641",
              "startDate": this.rangeDate[0],
              "endDate": this.rangeDate[1]
            }
        },
        "exportFileName": exportFileName
      }
      const res = await this.$http.postdown(this.$api.queryExport, en)     
      // console.log('Export', res)
      if (res.status === 200) {
        this.$fileDownload(res.data, `${exportFileName}.xlsx`)
      } else {
        this.$message.error(res.statusText)
      }
    }
  }
}
</script>

<style>
</style>
